import { useState, VFC } from 'react'
import { MemberPageWrapper } from 'src/components/PageWrapper'
import { Event } from 'src/models/Event'
import { LoginUser } from 'src/models/User'
import { _contributiontext, truewhite } from 'src/styles/colors'
import { fontWeightBold } from 'src/styles/font'
import styled from 'styled-components'
import { EventDetailListItem } from './EventDetailListItem'
import { EventFormBase } from './EventFormBase'
import { EventFormModal } from './EventFormModal'
import { EventBottomButton, EventThumbnail } from './styles'

type EventDetailLayoutProps = {
  user: LoginUser
  event: Event
}
export const EventDetailLayout: VFC<EventDetailLayoutProps> = ({
  user,
  event,
}) => {
  const [isFormModalOpen, setIsFormModalOpen] = useState(false)

  return (
    <>
      <MemberPageWrapper user={user}>
        <EventDetailWrap>
          <EventDetailLeftColumn>
            <EventDetailTopLayout>
              <h2>{event.name}</h2>
              <p>{event.openingAt.format('YYYY年M月D日H時mm分')}〜</p>
              <EventThumbnailWrapper>
                <EventThumbnail>
                  <img src={event.imageFile.url} alt="イベント" />
                </EventThumbnail>
              </EventThumbnailWrapper>
            </EventDetailTopLayout>
            <EventDetailList>
              <EventDetailListItem
                title="イベント概要"
                description={event.summary}
              />
              <EventDetailListItem
                title="当日の流れ"
                description={event.flowing}
              />
              <EventDetailListItem
                title="詳細情報"
                description={event.content}
              />
              <EventDetailListItem
                title="参加条件・注意事項"
                description={event.attention}
              />
            </EventDetailList>
          </EventDetailLeftColumn>
          {user.loggedIn && <EventDetailForm user={user} event={event} />}
        </EventDetailWrap>
        <EventBottomButtonWrapper>
          <EventBottomButton
            onClick={async () => {
              setIsFormModalOpen(true)
            }}
          >
            お申し込みはこちら
          </EventBottomButton>
        </EventBottomButtonWrapper>
      </MemberPageWrapper>

      {isFormModalOpen && (
        <EventFormModal
          close={() => setIsFormModalOpen(false)}
          user={user}
          event={event}
        />
      )}
    </>
  )
}

const EventDetailWrap = styled.div`
  padding: 20px 20px 0;
  width: 100%;
  @media screen and (min-width: 990px) {
    margin: 0 auto;
    padding: 20px 20px 50px;
  }
  @media screen and (min-width: 1280px) {
    display: flex;
    max-width: 1368px;
    margin: 0 auto;
    padding: 20px 50px;
  }
`

const EventDetailForm: VFC<{
  user: LoginUser
  event: Event
}> = ({ user, event }) => (
  <EventDetailFormLayout>
    <FormWrap>
      <EventFormBase user={user} event={event} />
    </FormWrap>
  </EventDetailFormLayout>
)
const EventDetailLeftColumn = styled.div`
  flex: 1;
`

const EventDetailTopLayout = styled.div`
  margin-bottom: 36px;

  h2 {
    font-weight: ${fontWeightBold};
    font-size: 18px;
    line-height: 1.5;
    letter-spacing: 0.05em;
    margin-bottom: 24px;
    @media screen and (min-width: 540px) {
      font-size: 28px;
    }
  }
  p {
    color: ${_contributiontext};
    font-weight: ${fontWeightBold};
    font-size: 12px;
    margin-bottom: 24px;
    @media screen and (min-width: 540px) {
      font-size: 18px;
    }
  }
`

const EventThumbnailWrapper = styled.div`
  width: 100%;
  @media screen and (min-width: 540px) {
    width: 424px;
  }
`

const EventDetailList = styled.ul`
  display: block;
`

const EventBottomButtonWrapper = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  padding: 24px 0 32px;
  background-color: #f8fcfa;
  @media screen and (min-width: 540px) {
    display: none;
  }
  > button {
    margin: 0 auto;
    max-width: 280px;
  }
`

const EventDetailFormLayout = styled.div`
  display: none;
  @media screen and (min-width: 540px) {
    display: block;
    width: 500px;
    margin: 0 auto 20px;
  }
  @media screen and (min-width: 1280px) {
    margin: 0 0 0 50px;
  }
`

export const FormWrap = styled.div`
  @media screen and (min-width: 540px) {
    display: block;
    width: 500px;
    height: fit-content;
    padding: 30px 40px;
    background-color: ${truewhite};
    border-radius: 10px;
    box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.16);
  }
`
